import "promise-polyfill/src/polyfill";
import objectFitImages from "object-fit-images";
import menu from "./menu";
import lightbox from "./lightbox";
import lightboxGallery from "./lightbox-gallery";
import team from "./team";
import forms from "./forms";

objectFitImages();
menu();
lightbox();
lightboxGallery();
team();
forms();
